import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import Loading from './loading'
import Window from './Window'
import Create from './create'
import ModalFolderName from './Modal/name'

const propTypes = {
  storage: PropTypes.object,
  defaults: PropTypes.object.isRequired,
  onCreateStorage: PropTypes.func,

  allowZipFolder: PropTypes.bool,
  allowCreate: PropTypes.bool,
  allowRename: PropTypes.bool,
  allowUpload: PropTypes.bool,
  allowDelete: PropTypes.bool,

  templates: PropTypes.array,

  data: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  secondaryLoading: PropTypes.bool.isRequired,
  executeAction: PropTypes.func.isRequired,
  executeDownload: PropTypes.func.isRequired,
  executeDownloadFolder: PropTypes.func.isRequired
}

const defaultProps = {
  created: true,
  allowToCreate: false,

  allowZipFolder: true,
  allowCreate: false,
  allowRename: false,
  allowUpload: false,
  allowDelete: false,

  defaults: {
    upload_folder: false,
    zip_folder: false,
    default_view: 'list'
  }
}

const root = {
  action: 'GET_ITEMS',
  fullname: '/',
  type: 'folder',
  relative: false
}

const rootBreadcrumb = {
  fullname: '/',
  name: 'Radix',
  type: 'folder',
  key: '/',
}

const FileManager = ({
  storage,
  defaults,

  onCreateStorage,
  data,
  loading,
  secondaryLoading,
  templates,
  executeAction,
  executeDownload,
  executeDownloadFolder,

  allowZipFolder,
  allowCreate,
  allowRename,
  allowUpload,
  allowDelete
}) => {
  const [selectedItem, setSelectedItem] = useState(null)
  const [currentFolderObject, setCurrentFolderObject] = useState(rootBreadcrumb)
  const [breadcrumbList, setBreadcrumbList] = useState([rootBreadcrumb])

  const [folderNameVisible, setFolderNameVisible] = useState(false)
  const [uploadVisible, setUploadVisible] = useState(false)

  const allowZip = defaults?.zip_folder ? allowZipFolder : false

  const getItems = (path) => {
    const form = {
      action: 'LIST_FOLDER',
      location: path
    }
    return executeAction(form)
  }

  const showNewFolderForm = () => {
    setSelectedItem(null)
    setFolderNameVisible(true)
  }

  const showRenameForm = (item) => {
    setSelectedItem(item)
    setFolderNameVisible(true)
  }

  const hideModalName = () => setFolderNameVisible(false)

  const onUploadFile = (form) => {
    return executeAction(form)
  }

  const onDeleteFile = (record) => {
    const form = {
      action: 'REMOVE_FILE',
      location: currentFolderObject.fullname,
      name: record.name,
      fullname: record.fullname
    }
    return executeAction(form)
  }

  const onRenameFile = (location, name, fullname, target_name) => {
    const form = {
      action: 'RENAME_FILE',
      location: location,
      name: name,
      fullname: fullname,
      target_name: target_name
    }
    return executeAction(form)
  }

  const onMoveFile = (record, name) => {
    const form = {
      action: 'FILE_MOVE',
      type: 'file',
      relative: false,
      fullname: record.fullname,
      target_fullname: name
    }
    return executeAction(form)
  }

  const onCreateFolder = (form) => executeAction(form)

  const onRenameFolder = (location, name, fullname, target_name) => {
    const form = {
      action: 'RENAME_FOLDER',
      location: location,
      name: name,
      fullname: fullname,
      target_name: target_name
    }
    return executeAction(form)
  }

  const onMoveFolder = (record, name) => {
    const form = {
      action: 'FOLDER_MOVE',
      type: 'folder',
      relative: false,
      fullname: record.fullname,
      target_fullname: name
    }
    return executeAction(form)
  }

  const onDeleteFolder = (record) => {
    const form = {
      action: 'REMOVE_FOLDER',
      location: currentFolderObject.fullname,
      name: record.name,
      fullname: record.fullname
    }
    return executeAction(form)
  }

  const onDownloadFolder = (meta) => executeDownloadFolder(currentFolderObject.fullname, meta)
  const download = (meta) => executeDownload(currentFolderObject.fullname, meta)

  useEffect(() => {
    if (storage?.created) {
      const ret = getItems('/')

      ret.then((response) => {
        // const newList = breadcrumbList.concat(response.data);
        // setBreadcrumbList(newList);
      }).catch((e) => {})
    }
  }, [storage?.created])

  const onChangeBreadcrumbs = (idx) => {
    const go = breadcrumbList[idx]

    const ret = getItems(go?.fullname)

    ret.then((response) => {
      const newList = breadcrumbList.slice(0, idx + 1)
      setBreadcrumbList(newList)

      setCurrentFolderObject(go)
    }).catch((e) => {})
  }

  const onClickFolder = (folder) => {
    const ret = getItems(folder?.fullname)
    ret.then((response) => {
      const newList = breadcrumbList.concat(folder)

      setBreadcrumbList(newList)
      setCurrentFolderObject(folder)
      // const newList = breadcrumbList.concat(response.data);
    }).catch((e) => {})
  }

  if (!storage?.created) {
    return <Create {...storage} templates={templates} onCreate={onCreateStorage} />
  }

  return (
    <>
      <Loading loading={loading || secondaryLoading} />
      <Window
        data={data}
        loading={loading}
        defaults={defaults}
        currentFolderObject={currentFolderObject}
        breadcrumbs={breadcrumbList}
        onChangeBreadcrumbs={onChangeBreadcrumbs}
        onClickFolder={onClickFolder}
        onCreateFolder={onCreateFolder}
        onMoveFolder={onMoveFolder}
        onDeleteFolder={onDeleteFolder}
        onUploadFile={onUploadFile}
        onMoveFile={onMoveFile}
        onDownloadFolder={onDownloadFolder}
        onDownloadFile={download}
        onDeleteFile={onDeleteFile}
        showNewFolderForm={showNewFolderForm}
        showRenameForm={showRenameForm}
        allowZip={allowZip}
        allowCreate={allowCreate}
        allowRename={allowRename}
        allowUpload={allowUpload}
        allowDelete={allowDelete}
      />

      <ModalFolderName
        currentFolder={currentFolderObject?.fullname}
        item={selectedItem}
        visible={folderNameVisible}
        onCreateFolder={onCreateFolder}
        onRenameFolder={onRenameFolder}
        onRenameFile={onRenameFile}
        onCancel={hideModalName}
      />
    </>
  )
}

FileManager.propTypes = propTypes
FileManager.defaultProps = defaultProps

export default FileManager
